import React from 'react';
import { useChat } from '../../contexts/ChatContext';
import { FiChevronRight } from 'react-icons/fi';

interface FollowUpSuggestionsProps {
  suggestions: string[];
  messageId: string; // ID of the message these follow-ups relate to
}

const FollowUpSuggestions: React.FC<FollowUpSuggestionsProps> = ({ suggestions, messageId }) => {
  const { sendMessage } = useChat();

  // Handle suggestion click
  const handleSuggestionClick = (suggestion: string) => {
    sendMessage(suggestion, {
      isFollowUp: true,
      contextMessageId: messageId
    });
  };

  return (
    <div className="flex flex-wrap gap-2">
      {suggestions.map((suggestion, index) => (
      <button
        key={index}
        onClick={() => handleSuggestionClick(suggestion)}
        className="bg-neutral-200 hover:bg-neutral-300 text-text-secondary dark:bg-dark-secondary dark:text-dark-text dark:hover:bg-dark-accent py-2 px-3 rounded-xl text-sm text-left transition-colors flex items-center gap-1"
      >
        <span>{suggestion}</span>
        <FiChevronRight/>
      </button>
      ))}
    </div>
  );
};

export default FollowUpSuggestions;
